import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  ReactiveFormsModule
} from '@angular/forms';
import { AuthService } from '../auth.service';
import { NewUser } from '../../user/user.model';
import { Router, RouterModule } from '@angular/router';
import { map } from 'rxjs/operators';

import { CheckService } from 'src/app/checks/check.service';
import { FormMessage } from 'src/app/ui-design-library/form-message/form-message.model';
import { intermediaryNumberValidator, allowedDomainValidator } from 'src/app/validators/custom-validators';
import { HttpErrorResponse } from '@angular/common/http';
import { IconComponent } from 'src/app/ui-design-library/icon/icon.component';
import { NgClass } from '@angular/common';
import { ShowErrorComponent } from 'src/app/ui-design-library/forms/show-error/show-error.component';
import { FormMessageComponent } from 'src/app/ui-design-library/form-message/form-message.component';

@Component({
  selector: 'fnsr-register',
  standalone: true,
  imports: [RouterModule, IconComponent, NgClass, ShowErrorComponent, FormMessageComponent, ReactiveFormsModule],
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  form!: FormGroup;
  isLoading = false;

  isValidatingEmail = false;
  isValidatingUsername = false;
  isValidatingIntermediaryNumber = false;
  formMessage?: FormMessage;

  constructor(
    public fb: FormBuilder,
    public authService: AuthService,
    public router: Router,
    public checkService: CheckService,
    // private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.createForm();
  }

  private createForm(): void {
    this.form = this.fb.group({
      intermediaryNumber: ['', {
        validators: [
          Validators.required,
          intermediaryNumberValidator
        ],
        asyncValidators: [this.isIntermediaryNumberAvailable.bind(this)],
        updateOn: 'blur'
      }],
      username: ['', {
        validators: [
          Validators.required,
          Validators.minLength(4)
        ],
        asyncValidators: [this.isUsernameAvailable.bind(this)],
        updateOn: 'blur'
      }],
      email: ['', {
        validators: [
          Validators.required,
          // barmeniaEmailValidator
          allowedDomainValidator
        ],
        asyncValidators: [
          this.isEmailAvailable.bind(this),
          this.checkEmailApproval.bind(this),
          // this.checkEmailForBarmeniaDomain.bind(this),
          this.checkEmailForAllowedDomain.bind(this)
        ],
        updateOn: 'blur'
      }],
      password: ['', {
        validators: [
          Validators.required,
          Validators.minLength(8)
        ],
        updateOn: 'blur'
      }]
    });
  }

  private isEmailAvailable(control: FormControl): any {
    this.isValidatingEmail = true;
    const email = control.value;
    const emailAvailability = this.checkService.isEmailAvailable(email);
    this.isValidatingEmail = false;

    return emailAvailability;
  }

  private checkEmailApproval(control: FormControl): any {
    this.isValidatingEmail = true;
    const email = control.value;
    const emailApproval = this.checkService.checkEmailApproval(email);
    this.isValidatingEmail = false;

    return emailApproval;
  }

  // private checkEmailForBarmeniaDomain(control: FormControl): any {
  //   this.isValidatingEmail = true;
  //   const email = control.value;

  //   return this.checkService.checkEmailForBarmeniaDomain(email).pipe(
  //     map(
  //       result => {
  //         this.isValidatingEmail = false;
  //         if (!result.hasBarmeniaDomain) {
  //           return { noBarmeniaDomain: true };
  //         }
  //         return null;
  //       },
  //       (err: Error) => {
  //         console.log(err);
  //         this.isValidatingEmail = false;
  //       }
  //     )
  //   );
  // }

  private checkEmailForAllowedDomain(control: FormControl): any {
    this.isValidatingEmail = true;
    const email = control.value;

    return this.checkService.checkEmailForAllowedDomain(email).pipe(
      map(
        result => {
          this.isValidatingEmail = false;
          if (!result.hasAllowedDomain) {
            return { noAllowedDomain: true };
          }
          return null;
        },
        (err: Error) => {
          console.log(err);
          this.isValidatingEmail = false;
        }
      )
    );
  }

  private isIntermediaryNumberAvailable(control: FormControl): any {
    this.isValidatingIntermediaryNumber = true;
    const intermediaryNumber = control.value;
    const intermediaryNumberAvailability = this.checkService.isIntermediaryNumberAvailable(intermediaryNumber);
    this.isValidatingIntermediaryNumber = false;

    return intermediaryNumberAvailability;
  }

  private isUsernameAvailable(control: FormControl): any {
    this.isValidatingUsername = true;
    const username = control.value;
    const usernameAvailability = this.checkService.isUsernameAvailable(username);
    this.isValidatingUsername = false;

    return usernameAvailability;
  }

  onSubmit(newUser: NewUser): void {
    this.isLoading = true;

    this.authService.register(newUser).subscribe(
      result => {
        this.formMessage = {
          message: result.message,
          messageType: 'success'
        };
        this.isLoading = false;
        this.authService.setUser(result);

        setTimeout(() => {
          this.router.navigate(['mail']);
        }, 1500);
      },
      (err: HttpErrorResponse) => {
        this.formMessage = {
          message: err.error.message,
          messageType: 'error'
        };
        this.isLoading = false;
      }
    );
  }


}
